import { useAct } from 'DashboardUser/store'

export default function SortingConfiguration({fieldId, closeConfiguration}) {
    const act = useAct();
    const dashboardField = useSel(s => s.dashboard.dashboardFields.find(f => f.id === fieldId) ?? null);

    const sortingField = useSel(s => s.local.sorting?.fieldId);
    const sortingDirection = useSel(s => s.local.sorting?.direction);

    if (!dashboardField) return null;

    const sortingSetDirection = sortingField === fieldId ? sortingDirection : null;

    const setSorting = (dir) => {
        if ((sortingField === fieldId && sortingDirection === dir) || (dir === null)) {
            act.local.setSorting(null);
        } else {
            act.local.setSorting(fieldId, dir);
        }
        closeConfiguration();
    }

    return <div className="sorting-configuration">
        <a href="#" className={`sorting-configuration-option ${sortingSetDirection === 'asc' ? 'active' : ''}`} onClick={() => setSorting('asc')}>
            Sort Ascending
        </a>
        <a href="#" className={`sorting-configuration-option ${sortingSetDirection === 'desc' ? 'active' : ''}`} onClick={() => setSorting('desc')}>
            Sort Descending
        </a>
        {sortingSetDirection && <a href="#" className="sorting-configuration-option configuration-option-clear" onClick={() => setSorting(null)}>Clear Sort</a>}
        <div className="filter-configuration-option-divider"></div>
    </div>
} 